var inview = function inview() {
  var elems = document.querySelectorAll('.js-inview');
  var CLASS = 'is-active';
  var options = {
    rootMargin: "-15%",
    threshold: 0
  };
  var callback = function callback(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add(CLASS);
      }
    });
  };
  var observer = new IntersectionObserver(callback, options);
  elems.forEach(function (elem) {
    observer.observe(elem);
  });
};
export default inview;